import axios from "axios";
import { apiUrl } from "../constant";

const createInvitation = (email) => {
  return axios.post(`${apiUrl}/api/Onboarding/create-invitation`, {
    email,
  });
};

const getInvitations = (pageIndex = 1, pageSize = 10) => {
  return axios.get(`${apiUrl}/api/Onboarding/get-invitations?pageIndex=${pageIndex}&pageSize=${pageSize}`);
};

const deleteInvitation = (id) => {
  return axios.post(`${apiUrl}/api/Onboarding/delete-invitation?id=${id}`);
};

export const OnboardingService = {
  createInvitation,
  getInvitations,
  deleteInvitation,
};

export default OnboardingService;
